import { GetMethod } from "../../methods/GetMethod";
import { IChecklistsByPartialSerialNumberResponse } from "../common/response.types";

export class GetChecklistsByPartialSerialNumber extends GetMethod<IChecklistsByPartialSerialNumberResponse> {
  constructor() {
    super(`${process.env.REACT_APP_API_URL}/checklists/serialnumbers/search`);
  }
}
